import React, { Fragment, useState,useContext } from 'react';
import "../../../../ui-styles/bottomSlider/BottomDetailsSlide.css";
import "../../../../ui-styles/list/AttachmentList.css";
import "../../../../ui-styles/fileView/FileView.css";
import { Document, Page, pdfjs   } from "react-pdf";
import { LangCtx } from '../../../../lib/context';
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

// import { MobilePDFReader } from 'reactjs-pdf-reader';

const PdfView = (props) => {
    const { l } = useContext(LangCtx);
    const { data } = props;
    const [numPages, setNumPages] = useState(null);
    const [pageNumber, setPageNumber] = useState(1);

    function onDocumentLoadSuccess({ numPages }) {
        setNumPages(numPages);
    }
    const prevClick = () => {
        setPageNumber(prevState => prevState - 1)
    }

    const nextClick = () => {
        setPageNumber(prevState => prevState + 1)
    }

    return <div className="mediaDocBackground">
        <div className="mediaViewBody">
            <div className="mediaViewBox">
                <div className="mediaFileContainer">
                    {/* <MobilePDFReader url={data && data.url ? data.url : ""} /> */}
                    <Fragment>
                        <nav className="pdfControls">
                            {pageNumber > 1 ? <button onClick={prevClick}>Prev</button> : <button disabled>Prev</button>}
                            {numPages && pageNumber < numPages ? <button onClick={nextClick}>{l.next}</button> : <button disabled>{l.next}</button>}
                        </nav>
                        <Document
                            file={data && data.url ? data.url : ""}
                            onLoadSuccess={onDocumentLoadSuccess}
                        >
                            <Page pageNumber={pageNumber} />
                        </Document>
                        <div className="pdfControls">
                            <p>Page {pageNumber} of {numPages}</p>
                        </div>
                    </Fragment>
                </div>
            </div>
        </div>
    </div>

}

export default PdfView;


// url: 'https://arxiv.org/pdf/quant-ph/0410100.pdf',